window["jQuery"] = require("jquery");
window["$"] = window["jQuery"];

window["moment"] = require("moment");
require('bootstrap/js/tooltip.js');
require('bootstrap/js/popover.js');
require('bootstrap/js/modal.js');
